import { createClient } from '@supabase/supabase-js';

/**
 * Cliente Supabase del navegador. La sesión se persiste en localStorage y el
 * token se refresca automáticamente; el backend valida el JWT en cada llamada.
 */
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
